var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart" }, [
    _vm.shippingPromoEnabled
      ? _c("div", { staticClass: "cart__shipping-promo--main-wrapper" }, [
          _vm.$mq !== "mobile" && _vm.$mq !== "tablet"
            ? _c(
                "div",
                {
                  staticClass: "cart__shipping-promo--wrapper container desktop"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cart__shipping-promo",
                      class: _vm.colors.shippingBg
                    },
                    [
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.normalizedTotalPrice < _vm.shippingPromoTotal
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "cart__shipping-promo-message body-sm-mobile body-md-tablet-up",
                                class: _vm.colors.shippingText
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    "Free shipping if you spend $" +
                                      _vm.remainingThresholdValue +
                                      (_vm.totalPrice === 0 ? "" : " more") +
                                      "."
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.normalizedTotalPrice >= _vm.shippingPromoTotal
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "cart__shipping-promo-message body-sm-mobile body-md-tablet-up",
                                class: _vm.colors.shippingText
                              },
                              [_vm._v(_vm._s(_vm.shippingPromoCopy))]
                            )
                          : _vm._e()
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "cart__shipping-promo-progress-bar-desktop"
                        },
                        [
                          _c("transition", { attrs: { name: "fade" } }, [
                            _c("div", {
                              staticClass: "cart__shipping-promo-progress-bar",
                              class: _vm.colors.shippingProgress,
                              style: {
                                width: _vm.remainingThresholdPercentage + "%"
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _c(
                "div",
                { staticClass: "cart__shipping-promo--wrapper mobile" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cart__shipping-promo",
                      class: _vm.colors.shippingBg
                    },
                    [
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.normalizedTotalPrice < _vm.shippingPromoTotal
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "cart__shipping-promo-message body-sm-mobile body-md-tablet-up",
                                class: _vm.colors.shippingText
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    "Free shipping if you spend $" +
                                      _vm.remainingThresholdValue +
                                      (_vm.totalPrice === 0 ? "" : " more") +
                                      "."
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.normalizedTotalPrice >= _vm.shippingPromoTotal
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "cart__shipping-promo-message body-sm-mobile body-md-tablet-up",
                                class: _vm.colors.shippingText
                              },
                              [_vm._v(_vm._s(_vm.shippingPromoCopy))]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _c("div", {
                    staticClass: "cart__shipping-promo-progress-bar",
                    class: _vm.colors.shippingProgress,
                    style: { width: _vm.remainingThresholdPercentage + "%" }
                  })
                ]
              )
        ])
      : _vm._e(),
    _vm.$mq !== "mobile" && _vm.$mq !== "tablet"
      ? _c("div", { staticClass: "cart__wrapper container" }, [
          _c("div", { staticClass: "cart__main" }, [
            _c("div", { staticClass: "cart__heading" }, [
              _c(
                "div",
                [
                  _c(
                    "v-link",
                    {
                      staticClass:
                        "cart__shipping-promo-continue-shopping u-hidden-mobile-only",
                      attrs: { primary: true, href: _vm.continueShoppingLink }
                    },
                    [_vm._v("Continue Shopping")]
                  )
                ],
                1
              ),
              _vm.totalItems > 0
                ? _c("div", { staticClass: "cart__heading-container" }, [
                    _c("h1", { staticClass: "h3" }, [
                      _vm._v("My Shopping Bag")
                    ]),
                    _c("span", { staticClass: "cart__heading-total" }, [
                      _vm._v(_vm._s(_vm.totalItems) + " items")
                    ])
                  ])
                : _vm._e()
            ]),
            _vm.totalItems > 0
              ? _c(
                  "div",
                  { staticClass: "cart__container" },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [
                        _c("div", { staticClass: "cart__contents-wrapper" }, [
                          _c("div", { staticClass: "cart__contents" }, [
                            _c(
                              "table",
                              { staticClass: "cart__table" },
                              [
                                _c(
                                  "tr",
                                  {
                                    staticClass: "cart__contents-table-header"
                                  },
                                  [
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "cart__contents-table-header--product strong-medium body-sm"
                                      },
                                      [_vm._v("Product")]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "cart__contents-table-header--price strong-medium body-sm"
                                      },
                                      [_vm._v("Price")]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "cart__contents-table-header--quantity strong-medium body-sm"
                                      },
                                      [_vm._v("Quantity")]
                                    )
                                  ]
                                ),
                                _vm._l(_vm.itemsNotInKits, function(
                                  item,
                                  index
                                ) {
                                  return _c("cart-line-item", {
                                    key: item.id,
                                    attrs: { item: item }
                                  })
                                }),
                                _vm.kits && _vm.kits.length
                                  ? _c(
                                      "div",
                                      _vm._l(_vm.kits, function(kit) {
                                        return _c("cart-line-item-kit", {
                                          key: kit.id,
                                          attrs: { kit: kit }
                                        })
                                      }),
                                      1
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "cart__empty" },
                  [
                    _c("p", { staticClass: "cart__empty__message h2" }, [
                      _vm._v(_vm._s(_vm.emptyText))
                    ]),
                    _vm._l(_vm.emptyLinkArray, function(link, index) {
                      return link.text
                        ? _c("v-button", {
                            key: index,
                            staticClass: "cart__empty__link",
                            attrs: {
                              primary: true,
                              href: link.url,
                              label: link.text,
                              tag: "a"
                            }
                          })
                        : _vm._e()
                    })
                  ],
                  2
                )
          ]),
          _vm.totalItems > 0
            ? _c("div", { staticClass: "cart__sidebar" }, [
                _c(
                  "div",
                  { staticClass: "cart__total-checkout bg-light-grey" },
                  [
                    _c("h2", { staticClass: "h4 text-center" }, [
                      _vm._v("Order Summary")
                    ]),
                    _c(
                      "div",
                      { staticClass: "cart__gift-messaging" },
                      [
                        _c(
                          "div",
                          { staticClass: "cart__gift-messaging-header" },
                          [
                            _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.giftEnabled,
                                    expression: "giftEnabled"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "gift_message_enable"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.giftEnabled)
                                    ? _vm._i(_vm.giftEnabled, null) > -1
                                    : _vm.giftEnabled
                                },
                                on: {
                                  click: _vm.toggleGift,
                                  change: function($event) {
                                    var $$a = _vm.giftEnabled,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.giftEnabled = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.giftEnabled = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.giftEnabled = $$c
                                    }
                                  }
                                }
                              }),
                              _c(
                                "label",
                                { attrs: { for: "gift_message_enable" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.giftEnabled
                                        ? "This is a gift!"
                                        : "Is this a gift?"
                                    )
                                  )
                                ]
                              )
                            ]),
                            _c(
                              "transition",
                              { attrs: { name: "fade", mode: "out-in" } },
                              [
                                _vm.giftEnabled
                                  ? _c(
                                      "v-link",
                                      {
                                        staticClass:
                                          "cart__gift-messaging-edit body-sm",
                                        attrs: { secondary: true },
                                        on: { click: _vm.addRemoveGiftMessage }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.giftMessageEnabled
                                              ? "Remove Message"
                                              : "Write a Message"
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "transition",
                          { attrs: { name: "fade", mode: "out-in" } },
                          [
                            _vm.giftEnabled && _vm.giftMessageEnabled
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "cart__gift-messaging-message"
                                  },
                                  [
                                    _c(
                                      "text-area-input",
                                      {
                                        staticClass:
                                          "cart__gift-messaging-textarea",
                                        attrs: {
                                          "char-limit": 250,
                                          label: "Gift Message",
                                          keydownEvent:
                                            _vm.debouncedUpdateGiftMessage
                                        },
                                        model: {
                                          value: _vm.giftMessage,
                                          callback: function($$v) {
                                            _vm.giftMessage = $$v
                                          },
                                          expression: "giftMessage"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.giftMessage))]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        _c("transition", { attrs: { name: "fade" } }, [
                          _vm.giftMessageConfirmationActive
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "cart__gift-messaging-message-confirmation body-sm"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.giftMessageConfirmationMessage)
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    ),
                    _c("div", { staticClass: "cart-summary" }, [
                      _c("div", { staticClass: "cart-summary__total" }, [
                        _c("h4", { staticClass: "cart-summary__subtotal" }, [
                          _vm._v("Subtotal")
                        ]),
                        _c("p", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("moneyWithoutDecimals")(_vm.totalPrice)
                              )
                          )
                        ])
                      ]),
                      _vm.savingsTotal > 0
                        ? _c("div", { staticClass: "cart-summary__savings" }, [
                            _c("span", { staticClass: "savings strong-bold" }, [
                              _vm._v("You saved ")
                            ]),
                            _c("span", { staticClass: "savings" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moneyWithoutDecimals")(
                                    _vm.savingsTotal
                                  )
                                )
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _c("v-button", {
                      staticClass:
                        "sidecart__checkout-cta button button--primary",
                      class: [
                        {
                          "sidecart__checkout-cta-promo-active":
                            _vm.promoMessage
                        }
                      ],
                      attrs: {
                        full: true,
                        type: "submit",
                        name: "checkout",
                        value: "Checkout",
                        label: "CHECKOUT"
                      },
                      on: { click: _vm.goToCheckout }
                    }),
                    _c("v-button", {
                      staticClass: "cart__checkout-cta gsx-checkout__button",
                      class: [
                        { "cart__checkout-cta-promo-active": _vm.promoMessage },
                        _vm.colors.cta
                      ],
                      attrs: {
                        full: true,
                        type: "submit",
                        name: "international checkout",
                        value: "Checkout",
                        label: "INTERNATIONAL CHECKOUT"
                      },
                      on: { click: _vm.goToIntlCheckout }
                    })
                  ],
                  1
                ),
                _vm.promoMessage
                  ? _c("div", { staticClass: "cart__promo" }, [
                      _c("p", { staticClass: "cart__promo__copy body-sm" }, [
                        _vm._v(_vm._s(_vm.promoMessage))
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ])
      : _c(
          "div",
          { staticClass: "cart__container-mobile" },
          [
            _vm.totalItems > 0
              ? _c(
                  "div",
                  { staticClass: "cart__heading-container container" },
                  [
                    _c("h1", { staticClass: "h4 text-center" }, [
                      _vm._v("My Shopping Cart")
                    ]),
                    _c("span", { staticClass: "cart__heading-total" }, [
                      _vm._v(_vm._s(_vm.totalItems) + " items")
                    ])
                  ]
                )
              : _vm._e(),
            _c("transition", { attrs: { name: "fade" } }, [
              _vm.totalItems > 0
                ? _c("div", { staticClass: "cart__contents-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "cart__contents" },
                      [
                        _vm._l(_vm.itemsNotInKits, function(item, index) {
                          return _c("sidecart-line-item", {
                            key: item.id,
                            attrs: { item: item }
                          })
                        }),
                        _vm.kits && _vm.kits.length
                          ? _c(
                              "div",
                              _vm._l(_vm.kits, function(kit) {
                                return _c("sidecart-line-item-kit", {
                                  key: kit.id,
                                  attrs: { kit: kit }
                                })
                              }),
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    ),
                    _c("div", { staticClass: "cart__footer" }, [
                      _c(
                        "div",
                        { staticClass: "cart__total-checkout bg-light-grey" },
                        [
                          _c("h3", { staticClass: "h4 text-center" }, [
                            _vm._v("Order Summary")
                          ]),
                          _c(
                            "div",
                            { staticClass: "cart__gift-messaging" },
                            [
                              _c(
                                "div",
                                { staticClass: "cart__gift-messaging-header" },
                                [
                                  _c("div", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.giftEnabled,
                                          expression: "giftEnabled"
                                        }
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        id: "gift_message_enable"
                                      },
                                      domProps: {
                                        checked: Array.isArray(_vm.giftEnabled)
                                          ? _vm._i(_vm.giftEnabled, null) > -1
                                          : _vm.giftEnabled
                                      },
                                      on: {
                                        click: _vm.toggleGift,
                                        change: function($event) {
                                          var $$a = _vm.giftEnabled,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.giftEnabled = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.giftEnabled = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.giftEnabled = $$c
                                          }
                                        }
                                      }
                                    }),
                                    _c(
                                      "label",
                                      { attrs: { for: "gift_message_enable" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.giftEnabled
                                              ? "This is a gift!"
                                              : "Is this a gift?"
                                          )
                                        )
                                      ]
                                    )
                                  ]),
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade", mode: "out-in" } },
                                    [
                                      _vm.giftEnabled
                                        ? _c(
                                            "v-link",
                                            {
                                              staticClass:
                                                "cart__gift-messaging-edit body-sm",
                                              attrs: { secondary: true },
                                              on: {
                                                click: _vm.addRemoveGiftMessage
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.giftMessageEnabled
                                                    ? "Remove message"
                                                    : "Write a message"
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "transition",
                                { attrs: { name: "fade", mode: "out-in" } },
                                [
                                  _vm.giftEnabled && _vm.giftMessageEnabled
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cart__gift-messaging-message"
                                        },
                                        [
                                          _c(
                                            "text-area-input",
                                            {
                                              staticClass:
                                                "cart__gift-messaging-textarea",
                                              attrs: {
                                                "char-limit": 250,
                                                label: "Gift Message",
                                                keydownEvent:
                                                  _vm.debouncedUpdateGiftMessage
                                              },
                                              model: {
                                                value: _vm.giftMessage,
                                                callback: function($$v) {
                                                  _vm.giftMessage = $$v
                                                },
                                                expression: "giftMessage"
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.giftMessage))]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _c("transition", { attrs: { name: "fade" } }, [
                                _vm.giftMessageConfirmationActive
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "cart__gift-messaging-message-confirmation body-sm"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.giftMessageConfirmationMessage
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          ),
                          _c("div", { staticClass: "cart-summary" }, [
                            _c("div", { staticClass: "cart-summary__total" }, [
                              _c(
                                "h4",
                                { staticClass: "cart-summary__subtotal" },
                                [_vm._v("Subtotal")]
                              ),
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("moneyWithoutDecimals")(
                                        _vm.totalPrice
                                      )
                                    )
                                )
                              ])
                            ]),
                            _vm.savingsTotal > 0
                              ? _c(
                                  "div",
                                  { staticClass: "cart-summary__savings" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "savings strong-bold" },
                                      [_vm._v("You saved ")]
                                    ),
                                    _c("span", { staticClass: "savings" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moneyWithoutDecimals")(
                                            _vm.savingsTotal
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _c("v-button", {
                            staticClass:
                              "sidecart__checkout-cta button button--primary",
                            class: [
                              {
                                "sidecart__checkout-cta-promo-active":
                                  _vm.promoMessage
                              }
                            ],
                            attrs: {
                              full: true,
                              type: "submit",
                              name: "checkout",
                              value: "Checkout",
                              label: "CHECKOUT"
                            },
                            on: { click: _vm.goToCheckout }
                          }),
                          _c("v-button", {
                            staticClass:
                              "cart__checkout-cta gsx-checkout__button",
                            class: [
                              {
                                "cart__checkout-cta-promo-active":
                                  _vm.promoMessage
                              },
                              _vm.colors.cta
                            ],
                            attrs: {
                              full: true,
                              type: "submit",
                              name: "international checkout",
                              value: "Checkout",
                              label: "INTERNATIONAL CHECKOUT"
                            },
                            on: { click: _vm.goToIntlCheckout }
                          })
                        ],
                        1
                      ),
                      _vm.promoMessage
                        ? _c("div", { staticClass: "cart__promo" }, [
                            _c("p", { staticClass: "cart__promo__copy" }, [
                              _vm._v(_vm._s(_vm.promoMessage))
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm.totalItems === 0
                ? _c(
                    "div",
                    { staticClass: "cart__empty" },
                    [
                      _c("p", { staticClass: "cart__empty__message h2" }, [
                        _vm._v(_vm._s(_vm.emptyText))
                      ]),
                      _vm._l(_vm.emptyLinkArray, function(link, index) {
                        return link.text
                          ? _c("v-button", {
                              key: index,
                              staticClass: "cart__empty__link",
                              attrs: {
                                primary: true,
                                href: link.url,
                                label: link.text,
                                tag: "a"
                              }
                            })
                          : _vm._e()
                      })
                    ],
                    2
                  )
                : _vm._e()
            ])
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }